import axios from "axios";

export const RECHARGE_PAYMENT_STATUS_STORAGE_KEY = "RechargePaymentStatus";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("LoginData") || "{}");
  } catch {
    return {};
  }
};

const getUserValue = (user, keys = []) => {
  for (const key of keys) {
    const value = user?.[key];

    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return value;
    }
  }

  return "";
};

const getRazorpayKey = async (baseUrl) => {
  if (process.env.REACT_APP_RAZORPAY_KEY_ID) {
    return process.env.REACT_APP_RAZORPAY_KEY_ID;
  }

  const response = await axios.post(`${baseUrl}user_api/u_paymentgateway.php`);
  const gateways = response?.data?.paymentdata || [];
  const razorpayGateway = gateways.find(
    (gateway) =>
      String(gateway?.id) === "4" ||
      String(gateway?.title || "").toLowerCase().includes("razorpay")
  );

  return razorpayGateway?.attributes || "";
};

export const saveRechargePaymentStatus = (details) => {
  sessionStorage.setItem(
    RECHARGE_PAYMENT_STATUS_STORAGE_KEY,
    JSON.stringify({
      updatedAt: new Date().toISOString(),
      ...details,
    })
  );
};

export const readRechargePaymentStatus = () => {
  try {
    return JSON.parse(
      sessionStorage.getItem(RECHARGE_PAYMENT_STATUS_STORAGE_KEY) || "{}"
    );
  } catch {
    return {};
  }
};

export const openRechargeRazorpay = async ({
  baseUrl,
  amount,
  description,
  serviceLabel,
}) => {
  if (!window.Razorpay) {
    throw new Error("Razorpay checkout is not available. Please refresh and try again.");
  }

  const numericAmount = Number(amount);

  if (!numericAmount || numericAmount <= 0) {
    throw new Error("Enter a valid payment amount.");
  }

  const [orderResponse, razorpayKey] = await Promise.all([
    axios.post(`${baseUrl}user_api/create_order.php`, { amount: numericAmount }),
    getRazorpayKey(baseUrl),
  ]);

  const orderData = orderResponse?.data || {};
  const orderId = orderData?.order_id || orderData?.razorpay_order_id;

  if (!orderData?.status || !orderId || !razorpayKey) {
    throw new Error(orderData?.message || "Unable to start Razorpay payment.");
  }

  const user = getStoredUser();

  return new Promise((resolve, reject) => {
    const checkout = new window.Razorpay({
      key: orderData?.razorpay_key || orderData?.key || razorpayKey,
      amount: orderData?.amount,
      currency: orderData?.currency || "INR",
      name: "Nabhiverse",
      description: description || serviceLabel || "Recharge payment",
      order_id: orderId,
      image: "/android-icon-192x192.png",
      handler: (response) => {
        sessionStorage.setItem("Paymentstatus", "PaymentDone");
        sessionStorage.setItem("RazorpayOrderId", response?.razorpay_order_id || orderId);

        resolve({
          ...response,
          razorpay_order_id: response?.razorpay_order_id || orderId,
          checkout_order_id: orderId,
        });
      },
      modal: {
        ondismiss: () => {
          sessionStorage.setItem("Paymentstatus", "PaymentFaild");
          reject(new Error("Payment was cancelled."));
        },
      },
      prefill: {
        name: getUserValue(user, ["name", "f_name"]),
        contact: getUserValue(user, ["mobile", "mobileNo", "phone"]),
        email: getUserValue(user, ["email"]),
      },
      notes: {
        service: serviceLabel || "Recharge",
      },
      theme: {
        color: "#d2a347",
      },
    });

    checkout.on("payment.failed", (response) => {
      sessionStorage.setItem("Paymentstatus", "PaymentFaild");
      sessionStorage.setItem(
        "RazorpayOrderId",
        response?.error?.metadata?.order_id || orderId
      );
      reject(
        new Error(
          response?.error?.description ||
            response?.error?.reason ||
            "Razorpay payment failed."
        )
      );
    });

    checkout.open();
  });
};
